import { render, staticRenderFns } from "./VMedia.vue?vue&type=template&id=6affbef7&scoped=true&"
import script from "./VMedia.vue?vue&type=script&lang=ts&"
export * from "./VMedia.vue?vue&type=script&lang=ts&"
import style0 from "./VMedia.vue?vue&type=style&index=0&id=6affbef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affbef7",
  null
  
)

export default component.exports